import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '首页', href: '/' },
  { label: '已核实报道', href: '/reports' },
  { label: '投稿入口', href: '/submit' },
  { label: '关于我们', href: '/about' },
];

const categoryLinks = [
  { label: '消费维权', href: '/reports?cat=consumer' },
  { label: '社会民生', href: '/reports?cat=society' },
  { label: '食品安全', href: '/reports?cat=food' },
  { label: '网络欺诈', href: '/reports?cat=digital' },
  { label: '公共环境', href: '/reports?cat=environment' },
  { label: '物业纠纷', href: '/reports?cat=property' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      {/* CTA strip */}
      <div className="bg-primary-500 py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-heading text-xl font-bold text-background-50">你有料，我们来核实</p>
            <p className="text-sm text-background-50/80 mt-1">17爆料私信通道始终开放，线索保密，安全可信</p>
          </div>
          <Link
            to="/submit"
            className="px-6 py-2.5 bg-background-50 text-primary-600 font-semibold text-sm rounded-md hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            立即投稿 / 私信
          </Link>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 grid grid-cols-1 sm:grid-cols-3 gap-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 flex items-center justify-center rounded bg-primary-500 text-background-50 font-bold text-sm">17</span>
            <span className="font-heading font-bold text-lg text-background-50">爆料</span>
          </div>
          <p className="text-sm text-background-400 leading-relaxed">
            17爆料是一个线索征集与核实发布平台。我们欢迎每一位关注公共事务、有亲历见闻的普通人通过17爆料投稿或私信提供线索，让真相被更多人看到。
          </p>
          <p className="mt-4 text-xs text-background-500">联系我们：tips@17baoliao.com</p>
        </div>

        {/* Nav links */}
        <div>
          <h4 className="text-sm font-semibold text-background-50 mb-3 uppercase tracking-widest">
            <a id="footer-nav">导航</a>
          </h4>
          <ul className="flex flex-col gap-2">
            {footerLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  rel="nofollow"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Categories */}
        <div>
          <h4 className="text-sm font-semibold text-background-50 mb-3 uppercase tracking-widest">
            <a id="footer-categories">报道栏目</a>
          </h4>
          <ul className="flex flex-wrap gap-2">
            {categoryLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-xs px-2.5 py-1 rounded bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-800 py-4 px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-500">
          <p>&copy; {new Date().getFullYear()} 17爆料 · 线索核实发布平台</p>
          <p>内容经编辑部核实后发布，仅代表平台立场</p>
        </div>
      </div>
    </footer>
  );
}